// Lightweight global trigger for the low-credits popup, decoupled from the React
// tree. Any feature can call triggerLowCreditsModal() (e.g. on a NO_CREDITS API
// error); DashboardLayout listens for the event and shows the modal.
//
// Optional `options.onBuyCredits` runs (awaited) when the user clicks "Buy
// Credits", before navigating to the plans page — e.g. single listing passes a
// save-draft handler so progress isn't lost.
export const LOW_CREDITS_EVENT = 'eb:show-low-credits';

export function triggerLowCreditsModal(options = {}) {
    window.dispatchEvent(new CustomEvent(LOW_CREDITS_EVENT, { detail: options }));
}
